import apiClient from '../../../services/apiClient';
import { unwrapData, unwrapPaginated } from './settingsResponse';

export const userSettingsApi = {
  listUsers: async (schoolId, { search = '', page = 1, pageSize = 100 } = {}) => {
    const response = await apiClient.get(`/schools/${schoolId}/users/`, {
      params: {
        search: search || undefined,
        page,
        page_size: pageSize,
      },
    });
    return unwrapPaginated(response.data);
  },

  createUser: async (schoolId, payload) => {
    const response = await apiClient.post(
      `/schools/${schoolId}/users/create/`,
      payload,
    );
    return unwrapData(response.data);
  },

  getUser: async (schoolId, userId) => {
    const response = await apiClient.get(
      `/schools/${schoolId}/users/${userId}/`,
    );
    return unwrapData(response.data);
  },

  updateUser: async (schoolId, userId, payload) => {
    const response = await apiClient.patch(
      `/schools/${schoolId}/users/${userId}/update/`,
      payload,
    );
    return unwrapData(response.data);
  },

  updateUserStatus: async (schoolId, userId, isActive) => {
    const response = await apiClient.patch(
      `/schools/${schoolId}/users/${userId}/status/`,
      { is_active: isActive },
    );
    return unwrapData(response.data);
  },
};
